import { Table } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

function TableComponent(props: PropTypes<any>) {

  const { t } = useTranslation("Tabs");
  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>
            {t("Parameter")}
          </th>
          {props.headers.map((header: string) => (
            <th key={header}>{header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Object.keys(props.data).map((row: string) => (
          <tr key={row}>
            <td key={row}>{row}</td>
            {props.headers.map((header: string) => (
              <td key={header + row}>{props.data[row][header]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

type PropTypes<T extends string[]> = {
  headers: T;
  data: KeyArrayToObject<T>;
};
type KeyArrayToObject<T extends string[]> = {
  [key: string]: { [K in T[number]]: string };
};
export default TableComponent;
